export default function EditDemoDialogController(
  $scope,

  ssDialogService,
  loaderService,
  alerts
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditDemoSubmit = _handleEditDemoSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {

  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.demo.editDemoDialog);
  }

  function _handleEditDemoSubmit() {
    if ($scope.editDemoForm.$valid) {
      loaderService.showViewLoader = true;
      _closeDialog().then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The Demo has saved successfully.');
      });
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.demo.editDemoDialog);
  }
}

EditDemoDialogController.$inject = [
  '$scope',

  'ssDialogService',
  'loaderService',
  'alerts',
];
